import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { Reveal } from "@/components/landing/Reveal";

export const SmartValve = () => (
  <section data-testid="smart-valve-section" className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="rounded-3xl bg-tlime p-8 sm:p-12 flex flex-col lg:flex-row items-start lg:items-center gap-8 justify-between">
          <div className="flex items-start gap-5">
            <ShieldCheck className="w-12 h-12 text-navy shrink-0" strokeWidth={1.5} />
            <div>
              <h3 className="font-bebas text-4xl sm:text-5xl text-navy leading-[0.9]">
                STOP LEAKS <span className="text-tpink">BEFORE THEY START?</span>
              </h3>
              <p className="mt-3 text-navy/75 max-w-xl">
                An AI valve that sniffs out leaks and shuts your water off before damage happens.
                It never sleeps, so you can.
              </p>
            </div>
          </div>
          <a
            data-testid="smart-valve-link"
            href={CONTACT.smartValve}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-navy text-white font-bebas text-xl tracking-wide px-8 py-3.5 hover:bg-navy-light hover:-translate-y-0.5 transition-[transform,background-color] duration-300"
          >
            TELL ME MORE <ArrowUpRight className="w-5 h-5" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
